import store from 'store2';
import { StorageType } from './storage';
export function storageProxy(type, prefix) {
    const storage = type === StorageType.Local ? store.local : store.session;
    function storageKey(property) {
        return `${prefix}${property}`;
    }
    const proxy = new Proxy({}, {
        get(_target, property, _receiver) {
            return storage.get(storageKey(property));
        },
        set(_target, property, value, _receiver) {
            if (value === undefined || value === null) {
                storage.remove(storageKey(property));
            }
            else {
                storage.set(storageKey(property), value);
            }
            return true;
        }
    });
    return proxy;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZVByb3h5LmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInN0b3JhZ2Uvc3RvcmFnZVByb3h5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxNQUFNLFFBQVEsQ0FBQTtBQUMxQixPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sV0FBVyxDQUFBO0FBTXZDLE1BQU0sVUFBVSxZQUFZLENBQUssSUFBaUIsRUFBRSxNQUFjO0lBQ2hFLE1BQU0sT0FBTyxHQUFHLElBQUksS0FBSyxXQUFXLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFBO0lBRXhFLFNBQVMsVUFBVSxDQUFFLFFBQWdCO1FBQ25DLE9BQU8sR0FBRyxNQUFNLEdBQUcsUUFBUSxFQUFFLENBQUE7SUFDL0IsQ0FBQztJQUVELE1BQU0sS0FBSyxHQUFHLElBQUksS0FBSyxDQUFDLEVBQVMsRUFBRTtRQUNqQyxHQUFHLENBQUUsT0FBZ0MsRUFBRSxRQUFnQixFQUFFLFNBQWM7WUFDckUsT0FBTyxPQUFPLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFBO1FBQzFDLENBQUM7UUFDRCxHQUFHLENBQUUsT0FBZ0MsRUFBRSxRQUFnQixFQUFFLEtBQVUsRUFBRSxTQUFjO1lBQ2pGLElBQUksS0FBSyxLQUFLLFNBQVMsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO2dCQUN6QyxPQUFPLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFBO2FBQ3JDO2lCQUFNO2dCQUNMLE9BQU8sQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFBO2FBQ3pDO1lBQ0QsT0FBTyxJQUFJLENBQUE7UUFDYixDQUFDO0tBQ0YsQ0FBQyxDQUFBO0lBRUYsT0FBTyxLQUFLLENBQUE7QUFDZCxDQUFDIn0=